<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row justify-content-center">
                    <div class="col-lg-3">
                        <label >SKU </label>
                        <input type="text" v-model="material.Codigo" class="form-control" placeholder="SKU" />
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Codigo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>

                    <div class="col-lg-7">
                        <label >Ítem </label>
                        <input type="text" v-model="material.Item" class="form-control" placeholder="Ítem" @input="onInput" @blur="hideSuggestions" @focus="onFocus"/>
						<ul v-if="ShowList && ItemFiltrado.length">
							<li v-for="(item,index) in ItemFiltrado" :key="index" @mousedown.prevent="selectSuggestion(item)">
								{{item.Item}}
							</li>
						</ul>
						<!-- <datalist>
							<option v-for="(item,index) in Items" :value="item.Item" :key="index">{{item.Item}}</option>
						</datalist> -->
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
                    <div class="col-lg-2 ">
                        
                            <label >Costo Unit. </label>
                            <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="material.Precio"></vue-numeric>
                           
                      
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Precio" :Mensaje="this.errorvalidacion.Precio[1]"></Cvalidation></label>
                    </div>
                    <!--fin col-6-->
                </div>
				<div class="row">
					<div class="col-lg-3">
						<label for="">Unidad</label>
						<input type="text" class="form-control" v-model="material.Unidad" placeholder="Unidad">
						<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="this.errorvalidacion.Unidad[0]"></Cvalidation></label>
					</div>
					<div class="col-lg-2">
						<label for="">Stock</label>
						<input type="number" class="form-control" v-model="material.Stock" placeholder="Stock">
						<!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Stock" :Mensaje="this.errorvalidacion.Stock[0]"></Cvalidation></label> -->
					</div>
					<div class="col-lg-7">
						<label for="">Descripción</label>
						<textarea v-model="material.NomMaterial" maxlength="70" cols="30" rows="4" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
                <!--Fin body del panel-->
            </template>
        </CLoader>
    </div>
     
</template>
<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'

export default {
    name:'Form',
    props:['NameList','poBtnSave'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'tipounidad',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            material:{            
                IdMaterial:0,
                Codigo:"",
                NomMaterial:"",
                Precio:"",
				Item:"",
				Unidad:"",
				Stock:0
            },
            urlApi:"cotizacion_material/recovery",
            errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion,
			Items:[],
			ShowList:false
        }
    },
    components:{
        Cbtnsave,
        Clist,Cvalidation,
    },
    methods :
    {
    
       async Guardar()
        {
             //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
            await this.$http.post(
                'cotizacion_material/post',
                this.material
                ,
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion); 

            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  

            });
       
        },
         Limpiar()
        {
            this.material.IdMaterial=0;
            this.material.NomMaterial="";
            this.material.Codigo="";
            this.material.Precio="";
			this.material.Item="";
			this.material.Unidad="";
			this.material.Stock=0;
            this.errorvalidacion=[];
            
        },
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdMaterial: this.material.IdMaterial}
                }
            ).then( (res) => {
                this.material=res.data.data.material;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		ListItem(){
			this.$http.get('cotizacion_material_item/get').then((res)=>{
				this.Items=res.data.data.row;
			})
		},
		onInput() {
    	  	this.ShowList = true;
    	},
    	selectSuggestion(item) {
    	  	this.material.Item = item;
    	  	this.ShowList = false;
    	},
		hideSuggestions() {
     		 // Delay to allow click event on suggestion to trigger before hiding
     		 setTimeout(() => {
     		   this.ShowList = false;
     		 }, 100);
    	},
		onFocus() {
      		if (this.material.Item) {
        		this.ShowList = true;
      		}
    	},

    },
    created() {
        this.bus.$off('Save_'+this.EmitSeccion);
        this.bus.$off('NewModal_'+this.EmitSeccion);

        this.bus.$on('Save_'+this.EmitSeccion,()=>
        {
           this.Guardar();
        });
        
        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {   this.ListItem();
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
             this.Limpiar();
            if (Id>0)
            {
                this.material.IdMaterial=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
            
        });
       
    },
	computed: {
		ItemFiltrado(){
			const input = this.material.Item.toLowerCase();
      		return this.Items.filter((item) =>
      		  item.toLowerCase().includes(input)
      		);
		}
	},
}
</script>
